import { Minute } from '@nu-art/ts-common';
import { Const_LaunchDeploy, UrlParam_EnvironmentId, UrlParam_FacilityId } from '@app/org-shared';
import { HttpMethod } from '@nu-art/thunderstorm-shared';
// Constants
export const Default_EHRID = '0cd819c692decf55f41710cdcfee187c';
export const HeaderKey_AdvisorSessionId = `x-advisor-session-id`;
export { Const_LaunchDeploy, UrlParam_EnvironmentId, UrlParam_FacilityId };
export const ApiDef_Launch = {
    _v1: {
        getLaunchUrl: { method: HttpMethod.POST, path: '/get-launch-url', timeout: Minute }
    }
};
